import { Injectable } from '@angular/core';
import { Http, QueryHandlerFor, Wrapper } from '@skylab-angular-shared/core';
import { AdvanceSummaryQuery, AdvanceSummaryQueryHandlerBase } from '@skylab-shared/business';

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(AdvanceSummaryQuery)
@Wrapper(AdvanceSummaryQueryHandlerBase)
export class AdvanceSummaryQueryHandler {
    public constructor(
        http: Http
    ) { }
}
